import React from 'react';

import { styled } from '../theme';
import { FlexColumn } from './index';

type Props = {
    inProgress: boolean;
    now: number;
    label?: string;
    className?: string;
    style?: React.CSSProperties;
    height?: number;
};

const Container = styled(FlexColumn)({
    padding: '2px 4px',
});

const PercentsContainer = styled('span')<Props>(({ theme, now }) => ({
    width: `${now}%`,
    textAlign: 'right',
    paddingBottom: 2,
    color: theme.color.primary1,
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: '1.4rem',
}));

const BarContainer = styled('div')<Props>(({ theme, height }) => ({
    borderRadius: theme.borderRadius.base,
    background: theme.color.backgroundGray,
    height,
}));

const Progress = styled('div')<Props>(({ theme, now, height }) => ({
    borderRadius: theme.borderRadius.base,
    background: theme.color.primary1,
    height,
    width: `${now}%`,
}));

const ProgressBar: React.FC<Props> = ({ now, inProgress, label, style, className, height = 8 }) =>
    inProgress ? (
        <Container className={className} style={style}>
            {label && <PercentsContainer now={now}>{label}</PercentsContainer>}
            <BarContainer height={height}>
                <Progress now={now} height={height} />
            </BarContainer>
        </Container>
    ) : null;

export default ProgressBar;
